const routes = {
  upload: '/upload'
};

export default routes;
